import Vue from 'vue'
import store from '@/store'

const typeNofityArr=['error','warn','info','success']
const typeTerminalArr=['ERROR','WARNING','INFO','SUCCESS']

const notificationTerminal={
  typesNotif:{
    ERROR:0,
    WARNING:1,
    INFO:2,
    SUCCESS:3
  },
  addNotification(type,title,message,zone,duration_ms=3000){
    Vue.notify({
      group: 'AppGeneralUser',
      title: title,
      type: typeNofityArr[type],
      text: message,
      duration:duration_ms
    })
    store.commit('ADD_MESSAGE_TERMINAL_SECTION',{
      type:typeTerminalArr[type],
      text:`${zone}. ${message}`
    })
  }
}

export default notificationTerminal